<template>
    <div class="index-page">
        <!-- 表单容器 -->
        <div class="form-container">
            <!-- 连锁名称 -->
            <van-cell-group>
                <van-field is-link v-model="formData.companyName" label="连锁名称" placeholder="请选择" style=" border-radius: 8px ;" readonly required @click="showChainPicker = true" />
            </van-cell-group>
            <!-- <van-field :value="formData.companyName" style="  border-radius: 8px ;" placeholder="请选择" label="连锁名称" readonly required @click="showChainPicker = true" class="form-item" :right-icon="'arrow-right'" /> -->
            <!-- 连锁名称选择器 - 弹窗形式 -->
            <van-popup v-model="showChainPicker" position="bottom" :style="{ height: '70%' }">
                <van-picker :columns="chainList" @confirm="onChainConfirm" @cancel="onChainCancel" show-toolbar title="选择连锁名称" />
            </van-popup>

            <!-- 标题信息 -->
            <div class="section-title">标题信息</div>

            <!-- 姓名 -->
            <van-field v-model="formData.name" placeholder="请输入" label="姓名" style="  border-radius: 8px 8px 0 0  ;" class="form-item" required @blur="onNameBlur" />

            <!-- 身份证号 -->
            <van-field v-model="formData.idCard" placeholder="请输入" required label="身份证号" @input="onIdCardInput" @blur="onIdCardBlur" class="form-item" />

            <!-- 年龄 -->
            <van-field :value="formData.age" placeholder="自动识别" label-class="selflabel" label="年龄" disabled class="form-item" />

            <!-- 性别 -->
            <van-field :value="formData.sex" placeholder="自动识别" label-class="selflabel" label="性别" disabled class="form-item" style=" border-radius: 0 0 8px 8px  ;" />

            <!-- 方便联系 -->
            <div class="section-title">方便跟您取得联系</div>

            <!-- 手机号 -->
            <van-field style="  border-radius: 8px ;" v-model="formData.mobile" placeholder="请输入" required label="手机号" type="number" class="form-item" @input="onPhoneInput" @blur="onPhoneBlur" />

            <!-- 上传证件 -->
            <div class="upload-item" style="  border-radius: 8px ;">
                <div style="width: 150px;margin-right: 20px;">
                    <label class="upload-label">
                        <span class="required-mark">*</span>
                        上传证件
                    </label>
                    <p class="upload-desc">请参照示例上传身份证人像面</p>
                    <div style="padding-left: 1em;">
                        <van-button type="primary" class="example" @click="viewPic">
                        查看示例
                    </van-button>
                    </div>
                </div>
                <div class="upload-container">
                    <van-uploader v-if="!fileList.length" v-model="fileList" :after-read="afterRead" :max-count="1" accept="image" class="uploader">
                        <div class="upload-icon-container">
                            <img style="width: 120px;
    height: 180px;" src="//assets/images/newCard.png" />
                            <img src="//assets/images/camera.png" class="camera" />
                        </div>
                    </van-uploader>
                    <div v-else class="upload-icon-container" @click="previewPic">                                             
                        <img style="width:120px;
    height:  180px;" :src="fileList[0]" />                                
                        <div @click.stop="deleteFile">
                            <img class="delete-icon" src="//assets/images/kasDel.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- 底部按钮容器 -->
        <div class="button-container">
            <van-button type="primary" class="submit-button" @click="submitForm">
                提交
            </van-button>
        </div>
    </div>
</template>

<script>
import { ImagePreview, Toast } from "vant";
export default {
    data() {
        return {
            formData: {
                companyName: '',
                name: '',
                idCard: '',
                age: '',
                sex: '',
                mobile: '',
                url: ''
            },
            chainList: [],
            showChainPicker: false,
            fileList: []
        }
    },
    mounted() {
        this.getMemberList()
    },
    methods: {
        async getMemberList() {
            const res = await this.$api.getMemberLists()
            if (res.data.code !== 200) return
            this.chainList = res.data.data.map(item => item.companyName)
        },
        // 连锁名称选择确认
        onChainConfirm(value) {
            this.formData.companyName = value;
            this.showChainPicker = false;
        },

        // 连锁名称选择取消
        onChainCancel() {
            this.showChainPicker = false;
        },
        previewPic() {
            ImagePreview(this.fileList);
        },
        viewPic() {
            ImagePreview(['https://b2b-img.hrjkjt.com/example.png']);
        },

        // 姓名失焦处理，校验是否包含'舒'字及长度是否在10以内
        onNameBlur() {
            const value = this.formData.name;
            if (value && value.length > 10) {
                this.$toast('姓名长度不能超过10个字符');
                this.formData.name = value.substring(0, 10); // 自动截断
                return
            }
            if (value && value.indexOf('舒') === -1) {
                this.$toast('您的姓名没有"舒"字，不可以参与此活动哦～');
            }
        },

        // 身份证号输入处理，自动识别年龄和性别，并限制只允许数字和字母输入
        onIdCardInput(value) {
            // 只允许数字和字母输入
            const validValue = value.replace(/[^a-zA-Z0-9]/g, '');
            if (validValue !== value) {
                this.formData.idCard = validValue;
                return;
            }

            if (validValue.length === 18) {
                this.autoIdentifyInfo(validValue);
            } else {
                // 当删除或者改动不足18位时自动清空年龄和性别
                this.formData.age = '';
                this.formData.sex = '';
            }
        },

        // 身份证号失焦校验
        onIdCardBlur() {
            if (this.formData.idCard && !this.isIdCard(this.formData.idCard)) {
                this.$toast('请输入正确的身份证号');
            }
        },

        // 根据身份证号自动识别年龄和性别
        autoIdentifyInfo(idCard) {
            // 获取出生年月日
            const birthYear = parseInt(idCard.substring(6, 10));
            const birthMonth = parseInt(idCard.substring(10, 12));
            const birthDay = parseInt(idCard.substring(12, 14));

            // 计算年龄
            const now = new Date();
            const nowYear = now.getFullYear();
            const nowMonth = now.getMonth() + 1;
            const nowDay = now.getDate();

            let age = nowYear - birthYear;
            if (nowMonth < birthMonth || (nowMonth === birthMonth && nowDay < birthDay)) {
                age--;
            }

            // 识别性别（第17位，奇数为男，偶数为女）
            const genderCode = parseInt(idCard.substring(16, 17));
            const sex = genderCode % 2 === 1 ? '男' : '女';

            this.formData.age = +age.toString();
            this.formData.sex = sex;
            if ((age < 10 || age > 55) && sex !== '女') {
                this.$toast('您的性别、年龄不符合活动要求，仅限于10-55岁的女性参与');
                return
            }

            // 自动检测年龄和性别是否达标
            if (age < 10 || age > 55) {
                this.$toast('您的年龄不符合活动要求，活动仅限10-55岁参与');
                return
            }

            if (sex !== '女') {
                this.$toast('您的性别不符合要求，活动仅限于女性参与');
                return
            }
        },

        // 上传图片处理
        async afterRead(files, detail) {
            console.log(files, detail);
            // 不压缩图片，直接使用原始图片
            const fd = new FormData();
            fd.append('idCard', files.file);
            const res = await this.$api.kasUpload(fd);
            this.fileList = [res.data.data.img];
            this.formData.url = res.data.data.img;

        },

        // 删除图片
        deleteFile() {
            this.fileList = [];
            this.formData.url = '';
            return true;
        },

        // 手机号输入处理，确保只能输入数字
        onPhoneInput(value) {
            // 只允许数字输入
            const validValue = value.replace(/[^0-9]/g, '');
            if (validValue !== value) {
                this.formData.mobile = validValue;
            }
        },

        // 手机号失焦校验
        onPhoneBlur() {
            if (this.formData.mobile && !this.isPhone(this.formData.mobile)) {
                this.$toast('请输入正确的手机号');
            }
        },

        // 表单验证
        validateForm() {
            if (!this.formData.companyName) {
                this.$toast('请选择连锁名称');
                return false;
            }
            if (!this.formData.name) {
                this.$toast('请输入姓名');
                return false;
            }
            // 校验姓名是否包含'舒'字
            if (this.formData.name && this.formData.name.indexOf('舒') === -1) {
                this.$toast('您的姓名没有"舒"字，不可以参与此活动哦～');
                return false;
            }
            if (!this.formData.idCard) {
                this.$toast('请输入身份证号');
                return false;
            } else if (!this.isIdCard(this.formData.idCard)) {
                this.$toast('请输入正确的身份证号');
                return false;
            }
            if ((this.formData.age < 10 || this.formData.age > 55) && this.formData.sex !== '女') {
                this.$toast('您的性别、年龄不符合活动要求，仅限于10-55岁的女性参与');
                return false;
            }
            // 校验年龄是否符合要求
            if (this.formData.age && (this.formData.age < 10 || this.formData.age > 55)) {
                this.$toast('您的年龄不符合活动要求，活动仅限10-55岁参与');
                return false;
            }
            // 校验性别是否符合要求
            if (this.formData.sex && this.formData.sex !== '女') {
                this.$toast('您的性别不符合要求，活动仅限于女性参与');
                return false;
            }
            if (!this.formData.mobile) {
                this.$toast('请输入手机号');
                return false;
            } else if (!this.isPhone(this.formData.mobile)) {
                this.$toast('请输入正确的手机号');
                return false;
            }
            if (this.fileList.length === 0) {
                this.$toast('请上传身份证人像面');
                return false;
            }
            return true;
        },

        // 身份证号验证
        isIdCard(idCard) {
            const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
            return reg.test(idCard);
        },

        // 手机号验证
        isPhone(mobile) {
            const reg = /^1[3456789]\d{9}$/;
            return reg.test(mobile);
        },

        // 提交表单
        async submitForm() {
            if (this.validateForm()) {
                // 构建提交数据

                // 这里可以添加提交表单的逻辑
                console.log('提交的表单数据：', this.formData);
                const res = await this.$api.submitInfo(this.formData)
                if (res.data.code == 200) {
                    // this.$message.success('提交成功')
                    Toast.success('提交成功')
                    this.formData = {}
                    this.fileList = []
                    this.showChainPicker = false
                } else {
                    this.$toast(res.data.msg)
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
/* 页面主容器 */
.index-page {
    background-color: #f5f5f5;
    //  min-height: 100vh;
    height: calc(100% - 65px) !important;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    padding: 10px 15px 60px;
    padding-bottom: calc(60px + constant(safe-area-inset-bottom));
    padding-bottom: calc(60px + env(safe-area-inset-bottom));
}
body {
    padding-bottom: 60px;
    padding-bottom: calc(60px + constant(safe-area-inset-bottom));
    padding-bottom: calc(60px + env(safe-area-inset-bottom));
}

/* 表单容器 */
.form-container {
    padding: 10px 0 30px;
    border-radius: 6px;
    box-shadow: none;
}

/* 表单字段 */
.form-item {
    font-size: 16px;
    height: 48px;
    line-height: 48px;
    --label-width: 80px;
    --border-color: #f5f5f5;
    background-color: #fff;
    margin-bottom: 0;
    padding: 0 15px;
    color: #555;
}

/* 区域标题 */
.section-title {
    font-size: 16px;
    color: #999;
    margin: 15px 0;
}

/* 必填标记样式 */
:deep(.van-field__label) {
    font-size: 16px;
    color: #333;
    width: 80px !important;
}

:deep(.van-field__label):before {
    content: '' !important;
}

/* 红色*号样式 */
:deep(.van-field__label) {
    &:first-letter {
        color: #ff3b30;
    }
}

/* 必填标记 */
.required-mark {
    color: #ff3b30 !important;
}

/* 上传区域 */
.upload-item {
    margin-top: 10px;
    padding: 10px 15px 20px 7px;
    background-color: #fff;
    display: flex;
}

.upload-label {
    display: block;
    font-size: 16px;
    color: #555;
    margin-bottom: 5px;
}

.upload-container {
    width: 120px;
    height: 180px;
    padding: 5px;
}

.upload-desc {
    font-size: 14px;
    color: #999;
    margin-top: 10px;
    margin-bottom: 10px;
   padding-left: 1em;
}
.example {
    padding: 15px;
    height: 35px;
    font-size: 14px;
    background: #337cff;
    border-radius: 50px;
    border: none;
    margin-top: 20px;
}
/* 上传组件 */
.uploader {
    display: block;
}

.upload-icon-container {
    height: 180px;
    width: 120px;
    border: 1px dashed #ddd;
    border-radius: 4px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    position: relative;
    background-image: url('/src/static/newCard.png');
    .camera {
        width: 45px;
        height: 45px;
        position: absolute;
    }
    .delete-icon {
        position: absolute;
        top: 8px;
        right: 8px;
        width: 15px;
        height: 15px;
    }
}

.upload-icon {
    text-align: center;
}

.upload-icon::before {
    content: '';
    position: absolute;
    top: 8px;
    left: 0;
    right: 0;
    height: 40px;
    background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="80" height="32" viewBox="0 0 80 32"><rect x="10" y="5" width="12" height="22" rx="2" fill="#e9e9e9"/><rect x="26" y="12" width="12" height="15" rx="2" fill="#e9e9e9"/><rect x="42" y="8" width="12" height="19" rx="2" fill="#e9e9e9"/><rect x="58" y="15" width="12" height="12" rx="2" fill="#e9e9e9"/></svg>')
        no-repeat center;
    background-size: 80% auto;
}

:deep(.van-uploader__preview) {
    width: 120px;
    height: 80px;
    border-radius: 4px;
    border: 0.5px solid #eee;
}

/* 底部按钮容器 */
.button-container {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 65px;
    background-color: #fff;
    padding-top: 15px;
    text-align: center;
    box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.05);
    z-index: 100;
}

/* 提交按钮 */
.submit-button {
    height: 45px;
    line-height: 45px;
    font-size: 16px;
    border-radius: 5px;
    background-color: #007aff;
    border: none;
    width: 90%;
}

/* 适配vant组件样式 */
:deep(.van-field) {
    background-color: #fff;
    border-bottom: 1px solid #f5f5f5;
    border-radius: 3px;
    margin-bottom: 10px;
    overflow: hidden;
}

:deep(.van-field__label) {
    font-size: 16px;
    color: #333;
    width: 80px !important;
}

:deep(.van-field__control) {
    font-size: 16px;
    color: #333;
    text-align: right;
}
:deep(.van-field__placeholder) {
    color: #ccc;
    text-align: right;
}

:deep(.van-icon-arrow-right) {
    color: #ccc;
}
</style>
<style >
   .van-field--disabled .selflabel{
color: #555 !important;

}

.van-field--disabled  .van-field__control{
    color: #333 !important;
    -webkit-text-fill-color: #333 !important;
}
 .van-field__control::-webkit-input-placeholder {
  color: #9b9da9 !important;
    -webkit-text-fill-color: #9b9da9!important;
}
.van-cell-group{
    border-radius: 8px;
    height: 48px;
 
}
.van-popup.van-popup--bottom{
height: 40% !important;
}
.van-cell{
   font-size: 16px !important;
}
.van-field__label{
    margin-right: 0 !important;
}
</style>